export const icons_doc = {
  pdf: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 100" width="70" height="88">
    <defs>
      <linearGradient id="pdf-grad" x1="0%" y1="0%" x2="0%" y2="100%"><stop offset="0%" style="stop-color:#EF5350"/><stop offset="100%" style="stop-color:#C62828"/></linearGradient>
    </defs>
    <path d="M5 8 Q5 3 10 3 H55 L75 23 V92 Q75 97 70 97 H10 Q5 97 5 92 Z" fill="white" stroke="#C62828" stroke-width="2"/>
    <path d="M55 3 L55 18 Q55 23 60 23 L75 23 Z" fill="#E0E0E0"/>
    <g transform="translate(18, 28) scale(0.17)">
      <path fill="#FA0F00" d="M204.144 147.657c-11.887-12.343-44.344-7.314-52.115-6.4-11.428-10.972-19.199-24.229-21.942-28.8 4.114-12.343 6.856-24.686 7.314-37.942 0-11.429-4.571-23.771-17.372-23.771-4.571 0-8.686 2.742-10.972 6.399-5.485 9.601-3.2 28.801 5.486 48.458-5.028 14.171-9.6 27.885-22.4 52.114-13.257 5.484-41.143 18.285-43.429 32-.914 4.113.457 8.229 3.657 11.428 3.2 2.743 7.314 4.114 11.429 4.114 16.914 0 33.371-23.313 44.8-42.972 9.6-3.199 24.686-7.771 39.772-10.514 17.828 15.543 33.371 17.828 41.6 17.828 10.971 0 15.086-4.571 16.457-8.686 2.285-4.57.914-9.599-2.285-13.256zm-11.43 7.772c-.457 3.2-4.57 6.399-11.885 4.571-8.686-2.285-16.457-6.4-23.314-11.886 5.943-.915 19.199-2.286 28.8-.457 3.657.914 7.314 3.2 6.399 7.772zm-76.342-94.172c.914-1.371 2.286-2.285 3.657-2.285 4.114 0 5.028 5.028 5.028 9.143-.457 9.601-2.286 19.2-5.485 28.343-6.858-18.286-5.486-31.087-3.2-35.201zm-.914 88.686c3.657-7.314 8.686-20.115 10.514-25.601 4.114 6.856 10.971 15.086 14.629 18.743 0 .458-14.172 3.2-25.143 6.858zm-26.972 18.286C77.972 185.6 67 196.571 61.057 196.571c-.914 0-1.829-.457-2.743-.914-1.372-.915-1.829-2.286-1.372-4.114 1.372-6.4 13.258-15.086 31.544-23.314z"/>
    </g>
    <rect x="5" y="75" width="70" height="22" rx="3" fill="url(#pdf-grad)"/>
    <text x="40" y="91" text-anchor="middle" fill="white" font-family="Arial,sans-serif" font-weight="bold" font-size="14">PDF</text>
  </svg>`,

  video2: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="60" height="60" viewBox="0 0 256 256" xml:space="preserve">
<g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;" transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
	<circle cx="51.022999999999996" cy="47.863" r="29.803" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(249,249,249); fill-rule: nonzero; opacity: 1;" transform="  matrix(1 0 0 1 0 0) "/>
	<path d="M 81.476 12.337 H 8.524 C 3.836 12.337 0 16.173 0 20.861 v 48.278 c 0 4.688 3.836 8.524 8.524 8.524 h 72.952 c 4.688 0 8.524 -3.836 8.524 -8.524 V 20.861 C 90 16.173 86.164 12.337 81.476 12.337 z M 61.223 46.633 L 36.762 60.756 c -1.257 0.726 -2.829 -0.181 -2.829 -1.633 V 30.877 c 0 -1.452 1.572 -2.36 2.829 -1.634 l 24.461 14.123 C 62.481 44.092 62.481 45.907 61.223 46.633 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(210,34,21); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"/>
</g>
</svg>`,

video : `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 50" width="60" height="60">
  <!-- Fond du bouton play YouTube -->
  <rect x="0" y="0" width="70" height="50" rx="10" ry="10" fill="#FF0000"/>
  <!-- Triangle play -->
  <polygon points="28,10 28,40 52,25" fill="#FFFFFF"/>
</svg>`,

youtube: `<svg xmlns="http://www.w3.org/2000/svg" width="240" height="60" viewBox="0 0 1024 256">
  <!-- Logo Play (même que video) -->
  <g transform="translate(20 38) scale(3.5)">
    <rect x="0" y="0" width="70" height="50" rx="10" ry="10" fill="#FF0000"/>
    <polygon points="28,10 28,40 52,25" fill="#FFFFFF"/>
  </g>
  <!-- Texte YouTube -->
  <text x="280" y="160" font-family="Arial, Helvetica, sans-serif" font-size="120" font-weight="bold" fill="#282828">YouTube</text>
</svg>`,

youtube2: `<svg xmlns="http://www.w3.org/2000/svg" width="240" height="60" viewBox="0 0 1024 256">
  <g transform="translate(0 0) scale(2.81 2.81)">
    <circle cx="51.023" cy="47.863" r="29.803" fill="rgb(249,249,249)"/>
    <path d="M 81.476 12.337 H 8.524 C 3.836 12.337 0 16.173 0 20.861 v 48.278 c 0 4.688 3.836 8.524 8.524 8.524 h 72.952 c 4.688 0 8.524 -3.836 8.524 -8.524 V 20.861 C 90 16.173 86.164 12.337 81.476 12.337 z M 61.223 46.633 L 36.762 60.756 c -1.257 0.726 -2.829 -0.181 -2.829 -1.633 V 30.877 c 0 -1.452 1.572 -2.36 2.829 -1.634 l 24.461 14.123 C 62.481 44.092 62.481 45.907 61.223 46.633 z" fill="rgb(210,34,21)"/>
  </g>
  <!-- Texte YouTube -->
  <text x="280" y="160" font-family="Arial, Helvetica, sans-serif" font-size="120" font-weight="bold" fill="#282828">YouTube</text>
</svg>`,

youtube3: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 100" width="300" height="60">
  <!-- Fond du bouton play YouTube -->
  <g transform="translate(10, 10)">
    <rect x="0" y="5" width="70" height="50" rx="10" ry="10" fill="#FF0000"/>
    <!-- Triangle play -->
    <polygon points="28,15 28,45 52,30" fill="#FFFFFF"/>
  </g>
  <!-- Texte YouTube -->
  <text x="90" y="48" font-family="Arial, Helvetica, sans-serif" font-size="36" font-weight="bold" fill="#282828">
    YouTube
  </text>
</svg>`,

  doc: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 100" width="70" height="88">
    <defs>
      <linearGradient id="doc-grad" x1="0%" y1="0%" x2="0%" y2="100%"><stop offset="0%" style="stop-color:#42A5F5"/><stop offset="100%" style="stop-color:#1565C0"/></linearGradient>
    </defs>
    <path d="M5 8 Q5 3 10 3 H55 L75 23 V92 Q75 97 70 97 H10 Q5 97 5 92 Z" fill="white" stroke="#1565C0" stroke-width="2"/>
    <path d="M55 3 L55 18 Q55 23 60 23 L75 23 Z" fill="#E0E0E0"/>
    <line x1="18" y1="35" x2="50" y2="35" stroke="#1565C0" stroke-width="2" stroke-linecap="round"/>
    <line x1="18" y1="45" x2="62" y2="45" stroke="#1565C0" stroke-width="2" stroke-linecap="round"/>
    <line x1="18" y1="55" x2="62" y2="55" stroke="#1565C0" stroke-width="2" stroke-linecap="round"/>
    <line x1="18" y1="65" x2="45" y2="65" stroke="#1565C0" stroke-width="2" stroke-linecap="round"/>
    <rect x="5" y="75" width="70" height="22" rx="3" fill="url(#doc-grad)"/>
    <text x="40" y="91" text-anchor="middle" fill="white" font-family="Arial,sans-serif" font-weight="bold" font-size="14">DOC</text>
  </svg>`,

  docx: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 100" width="70" height="88">
    <defs>
      <linearGradient id="docx-grad" x1="0%" y1="0%" x2="0%" y2="100%"><stop offset="0%" style="stop-color:#42A5F5"/><stop offset="100%" style="stop-color:#1565C0"/></linearGradient>
    </defs>
    <path d="M5 8 Q5 3 10 3 H55 L75 23 V92 Q75 97 70 97 H10 Q5 97 5 92 Z" fill="white" stroke="#1565C0" stroke-width="2"/>
    <path d="M55 3 L55 18 Q55 23 60 23 L75 23 Z" fill="#E0E0E0"/>
    <line x1="18" y1="35" x2="50" y2="35" stroke="#1565C0" stroke-width="2" stroke-linecap="round"/>
    <line x1="18" y1="45" x2="62" y2="45" stroke="#1565C0" stroke-width="2" stroke-linecap="round"/>
    <line x1="18" y1="55" x2="62" y2="55" stroke="#1565C0" stroke-width="2" stroke-linecap="round"/>
    <line x1="18" y1="65" x2="45" y2="65" stroke="#1565C0" stroke-width="2" stroke-linecap="round"/>
    <rect x="5" y="75" width="70" height="22" rx="3" fill="url(#docx-grad)"/>
    <text x="40" y="91" text-anchor="middle" fill="white" font-family="Arial,sans-serif" font-weight="bold" font-size="13">DOCX</text>
  </svg>`,

  odt: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 100" width="70" height="88">
    <defs>
      <linearGradient id="odt-grad" x1="0%" y1="0%" x2="0%" y2="100%"><stop offset="0%" style="stop-color:#42A5F5"/><stop offset="100%" style="stop-color:#1565C0"/></linearGradient>
    </defs>
    <path d="M5 8 Q5 3 10 3 H55 L75 23 V92 Q75 97 70 97 H10 Q5 97 5 92 Z" fill="white" stroke="#1565C0" stroke-width="2"/>
    <path d="M55 3 L55 18 Q55 23 60 23 L75 23 Z" fill="#E0E0E0"/>
    <line x1="18" y1="35" x2="50" y2="35" stroke="#1565C0" stroke-width="2" stroke-linecap="round"/>
    <line x1="18" y1="45" x2="62" y2="45" stroke="#1565C0" stroke-width="2" stroke-linecap="round"/>
    <line x1="18" y1="55" x2="62" y2="55" stroke="#1565C0" stroke-width="2" stroke-linecap="round"/>
    <line x1="18" y1="65" x2="45" y2="65" stroke="#1565C0" stroke-width="2" stroke-linecap="round"/>
    <rect x="5" y="75" width="70" height="22" rx="3" fill="url(#odt-grad)"/>
    <text x="40" y="91" text-anchor="middle" fill="white" font-family="Arial,sans-serif" font-weight="bold" font-size="14">ODT</text>
  </svg>`,

  ods: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 100" width="70" height="88">
    <defs>
      <linearGradient id="ods-grad" x1="0%" y1="0%" x2="0%" y2="100%"><stop offset="0%" style="stop-color:#66BB6A"/><stop offset="100%" style="stop-color:#2E7D32"/></linearGradient>
    </defs>
    <path d="M5 8 Q5 3 10 3 H55 L75 23 V92 Q75 97 70 97 H10 Q5 97 5 92 Z" fill="white" stroke="#2E7D32" stroke-width="2"/>
    <path d="M55 3 L55 18 Q55 23 60 23 L75 23 Z" fill="#E0E0E0"/>
    <rect x="15" y="32" width="50" height="38" fill="none" stroke="#2E7D32" stroke-width="2"/>
    <line x1="15" y1="44" x2="65" y2="44" stroke="#2E7D32" stroke-width="1.5"/>
    <line x1="15" y1="56" x2="65" y2="56" stroke="#2E7D32" stroke-width="1.5"/>
    <line x1="32" y1="32" x2="32" y2="70" stroke="#2E7D32" stroke-width="1.5"/>
    <line x1="48" y1="32" x2="48" y2="70" stroke="#2E7D32" stroke-width="1.5"/>
    <rect x="5" y="75" width="70" height="22" rx="3" fill="url(#ods-grad)"/>
    <text x="40" y="91" text-anchor="middle" fill="white" font-family="Arial,sans-serif" font-weight="bold" font-size="14">ODS</text>
  </svg>`,

  ppt: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 100" width="70" height="88">
    <defs>
      <linearGradient id="ppt-grad" x1="0%" y1="0%" x2="0%" y2="100%"><stop offset="0%" style="stop-color:#EF5350"/><stop offset="100%" style="stop-color:#C62828"/></linearGradient>
    </defs>
    <path d="M5 8 Q5 3 10 3 H55 L75 23 V92 Q75 97 70 97 H10 Q5 97 5 92 Z" fill="white" stroke="#C62828" stroke-width="2"/>
    <path d="M55 3 L55 18 Q55 23 60 23 L75 23 Z" fill="#E0E0E0"/>
    <rect x="15" y="32" width="50" height="35" rx="2" fill="none" stroke="#C62828" stroke-width="2"/>
    <rect x="20" y="37" width="20" height="10" rx="1" fill="#C62828" opacity="0.3"/>
    <line x1="20" y1="52" x2="45" y2="52" stroke="#C62828" stroke-width="2" stroke-linecap="round"/>
    <line x1="20" y1="59" x2="60" y2="59" stroke="#C62828" stroke-width="1.5" stroke-linecap="round"/>
    <rect x="5" y="75" width="70" height="22" rx="3" fill="url(#ppt-grad)"/>
    <text x="40" y="91" text-anchor="middle" fill="white" font-family="Arial,sans-serif" font-weight="bold" font-size="14">PPT</text>
  </svg>`,

  pptx: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 100" width="70" height="88">
    <defs>
      <linearGradient id="pptx-grad" x1="0%" y1="0%" x2="0%" y2="100%"><stop offset="0%" style="stop-color:#EF5350"/><stop offset="100%" style="stop-color:#C62828"/></linearGradient>
    </defs>
    <path d="M5 8 Q5 3 10 3 H55 L75 23 V92 Q75 97 70 97 H10 Q5 97 5 92 Z" fill="white" stroke="#C62828" stroke-width="2"/>
    <path d="M55 3 L55 18 Q55 23 60 23 L75 23 Z" fill="#E0E0E0"/>
    <rect x="15" y="32" width="50" height="35" rx="2" fill="none" stroke="#C62828" stroke-width="2"/>
    <rect x="20" y="37" width="20" height="10" rx="1" fill="#C62828" opacity="0.3"/>
    <line x1="20" y1="52" x2="45" y2="52" stroke="#C62828" stroke-width="2" stroke-linecap="round"/>
    <line x1="20" y1="59" x2="60" y2="59" stroke="#C62828" stroke-width="1.5" stroke-linecap="round"/>
    <rect x="5" y="75" width="70" height="22" rx="3" fill="url(#pptx-grad)"/>
    <text x="40" y="91" text-anchor="middle" fill="white" font-family="Arial,sans-serif" font-weight="bold" font-size="12">PPTX</text>
  </svg>`,

  xls: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 100" width="70" height="88">
    <defs>
      <linearGradient id="xls-grad" x1="0%" y1="0%" x2="0%" y2="100%"><stop offset="0%" style="stop-color:#66BB6A"/><stop offset="100%" style="stop-color:#2E7D32"/></linearGradient>
    </defs>
    <path d="M5 8 Q5 3 10 3 H55 L75 23 V92 Q75 97 70 97 H10 Q5 97 5 92 Z" fill="white" stroke="#2E7D32" stroke-width="2"/>
    <path d="M55 3 L55 18 Q55 23 60 23 L75 23 Z" fill="#E0E0E0"/>
    <rect x="15" y="32" width="50" height="38" fill="none" stroke="#2E7D32" stroke-width="2"/>
    <line x1="15" y1="44" x2="65" y2="44" stroke="#2E7D32" stroke-width="1.5"/>
    <line x1="15" y1="56" x2="65" y2="56" stroke="#2E7D32" stroke-width="1.5"/>
    <line x1="32" y1="32" x2="32" y2="70" stroke="#2E7D32" stroke-width="1.5"/>
    <line x1="48" y1="32" x2="48" y2="70" stroke="#2E7D32" stroke-width="1.5"/>
    <rect x="5" y="75" width="70" height="22" rx="3" fill="url(#xls-grad)"/>
    <text x="40" y="91" text-anchor="middle" fill="white" font-family="Arial,sans-serif" font-weight="bold" font-size="14">XLS</text>
  </svg>`,

  xlsx: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 100" width="70" height="88">
    <defs>
      <linearGradient id="xlsx-grad" x1="0%" y1="0%" x2="0%" y2="100%"><stop offset="0%" style="stop-color:#66BB6A"/><stop offset="100%" style="stop-color:#2E7D32"/></linearGradient>
    </defs>
    <path d="M5 8 Q5 3 10 3 H55 L75 23 V92 Q75 97 70 97 H10 Q5 97 5 92 Z" fill="white" stroke="#2E7D32" stroke-width="2"/>
    <path d="M55 3 L55 18 Q55 23 60 23 L75 23 Z" fill="#E0E0E0"/>
    <rect x="15" y="32" width="50" height="38" fill="none" stroke="#2E7D32" stroke-width="2"/>
    <line x1="15" y1="44" x2="65" y2="44" stroke="#2E7D32" stroke-width="1.5"/>
    <line x1="15" y1="56" x2="65" y2="56" stroke="#2E7D32" stroke-width="1.5"/>
    <line x1="32" y1="32" x2="32" y2="70" stroke="#2E7D32" stroke-width="1.5"/>
    <line x1="48" y1="32" x2="48" y2="70" stroke="#2E7D32" stroke-width="1.5"/>
    <rect x="5" y="75" width="70" height="22" rx="3" fill="url(#xlsx-grad)"/>
    <text x="40" y="91" text-anchor="middle" fill="white" font-family="Arial,sans-serif" font-weight="bold" font-size="13">XLSX</text>
  </svg>`,
};


export type IconDocKey = keyof typeof icons_doc;
export type IconDoc = typeof icons_doc[IconDocKey];



export const icons_doc4: Record<string, string> = {
  pdf: `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 130" width="70px" height="90px">
  <defs>
    <style>
      .pdf-main { fill: #E53935; }
      .pdf-fold { fill: #B71C1C; }
      .pdf-banner { fill: #C62828; }
      .text { font-family: Arial, sans-serif; font-weight: bold; fill: white; font-size: 26px; text-anchor: middle; }
      .icon-white { fill: white; }
    </style>
  </defs>
  <path d="M15 0 H70 L100 30 V125 A5 5 0 0 1 95 130 H15 A5 5 0 0 1 10 125 V5 A5 5 0 0 1 15 0 Z" class="pdf-main"/>
  <path d="M70 0 V30 H100 Z" class="pdf-fold"/>
  <path d="M70 0 L100 30 L70 30 Z" fill="#000" opacity="0.2"/>
  <rect x="10" y="85" width="90" height="35" rx="5" ry="5" class="pdf-banner"/>
  <text x="55" y="112" class="text">PDF</text>
  <path d="M 48 35 C 40 35 35 42 35 49 C 35 57 40 62 45 62 C 50 62 53 57 55 52 L 58 57 C 60 61 65 62 70 59 L 68 55 C 65 57 62 56 60 53 L 57 48 C 60 45 62 40 60 36 C 58 32 53 31 50 33 Z M 48 41 C 52 41 54 45 53 49 C 51 53 47 55 43 53 C 40 51 39 47 41 43 C 43 41 46 41 48 41 Z" class="icon-white" transform="translate(0, 5)"/>
</svg>`,

  doc: `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 130" width="70px" height="90px">
  <defs>
    <style>
      .doc-main { fill: #4285F4; }
      .doc-fold { fill: #3367D6; }
      .doc-banner { fill: #2a56c6; }
      .text { font-family: Arial, sans-serif; font-weight: bold; fill: white; font-size: 26px; text-anchor: middle; }
      .icon-white { fill: white; }
    </style>
  </defs>
  <path d="M15 0 H70 L100 30 V125 A5 5 0 0 1 95 130 H15 A5 5 0 0 1 10 125 V5 A5 5 0 0 1 15 0 Z" class="doc-main"/>
  <path d="M70 0 V30 H100 Z" class="doc-fold"/>
  <path d="M70 0 L100 30 L70 30 Z" fill="#000" opacity="0.2"/>
  <rect x="10" y="85" width="90" height="35" rx="5" ry="5" class="doc-banner"/>
  <text x="55" y="112" class="text">DOC</text>
  <rect x="30" y="40" width="50" height="6" rx="3" ry="3" class="icon-white"/>
  <rect x="30" y="52" width="50" height="6" rx="3" ry="3" class="icon-white"/>
  <rect x="30" y="64" width="35" height="6" rx="3" ry="3" class="icon-white"/>
</svg>`,

  docx: `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 130" width="70px" height="90px">
  <defs>
    <style>
      .docx-main { fill: #4285F4; }
      .docx-fold { fill: #3367D6; }
      .docx-banner { fill: #2a56c6; }
      .text-long { font-family: Arial, sans-serif; font-weight: bold; fill: white; font-size: 22px; text-anchor: middle; }
      .icon-white { fill: white; }
    </style>
  </defs>
  <path d="M15 0 H70 L100 30 V125 A5 5 0 0 1 95 130 H15 A5 5 0 0 1 10 125 V5 A5 5 0 0 1 15 0 Z" class="docx-main"/>
  <path d="M70 0 V30 H100 Z" class="docx-fold"/>
  <path d="M70 0 L100 30 L70 30 Z" fill="#000" opacity="0.2"/>
  <rect x="10" y="85" width="90" height="35" rx="5" ry="5" class="docx-banner"/>
  <text x="55" y="110" class="text-long">DOCX</text>
  <rect x="30" y="40" width="50" height="6" rx="3" ry="3" class="icon-white"/>
  <rect x="30" y="52" width="50" height="6" rx="3" ry="3" class="icon-white"/>
  <rect x="30" y="64" width="35" height="6" rx="3" ry="3" class="icon-white"/>
</svg>`,

  odt: `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 130" width="70px" height="90px">
  <defs>
    <style>
      .odt-main { fill: #4285F4; }
      .odt-fold { fill: #3367D6; }
      .odt-banner { fill: #2a56c6; }
      .text { font-family: Arial, sans-serif; font-weight: bold; fill: white; font-size: 26px; text-anchor: middle; }
      .icon-white { fill: white; }
    </style>
  </defs>
  <path d="M15 0 H70 L100 30 V125 A5 5 0 0 1 95 130 H15 A5 5 0 0 1 10 125 V5 A5 5 0 0 1 15 0 Z" class="odt-main"/>
  <path d="M70 0 V30 H100 Z" class="odt-fold"/>
  <path d="M70 0 L100 30 L70 30 Z" fill="#000" opacity="0.2"/>
  <rect x="10" y="85" width="90" height="35" rx="5" ry="5" class="odt-banner"/>
  <text x="55" y="112" class="text">ODT</text>
  <rect x="30" y="40" width="50" height="6" rx="3" ry="3" class="icon-white"/>
  <rect x="30" y="52" width="50" height="6" rx="3" ry="3" class="icon-white"/>
  <rect x="30" y="64" width="35" height="6" rx="3" ry="3" class="icon-white"/>
</svg>`,

  xls: `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 130" width="70px" height="90px">
  <defs>
    <style>
      .xls-main { fill: #34A853; }
      .xls-fold { fill: #2E8B57; }
      .xls-banner { fill: #257e4a; }
      .text { font-family: Arial, sans-serif; font-weight: bold; fill: white; font-size: 26px; text-anchor: middle; }
      .icon-white { fill: white; }
    </style>
  </defs>
  <path d="M15 0 H70 L100 30 V125 A5 5 0 0 1 95 130 H15 A5 5 0 0 1 10 125 V5 A5 5 0 0 1 15 0 Z" class="xls-main"/>
  <path d="M70 0 V30 H100 Z" class="xls-fold"/>
  <path d="M70 0 L100 30 L70 30 Z" fill="#000" opacity="0.2"/>
  <rect x="10" y="85" width="90" height="35" rx="5" ry="5" class="xls-banner"/>
  <text x="55" y="112" class="text">XLS</text>
  <path d="M30 40 H80 V75 H30 Z M30 52 H80 M30 64 H80 M46 40 V75 M63 40 V75" stroke="white" stroke-width="4" fill="none" class="icon-white"/>
</svg>`,

  xlsx: `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 130" width="70px" height="90px">
  <defs>
    <style>
      .xlsx-main { fill: #34A853; }
      .xlsx-fold { fill: #2E8B57; }
      .xlsx-banner { fill: #257e4a; }
      .text-long { font-family: Arial, sans-serif; font-weight: bold; fill: white; font-size: 22px; text-anchor: middle; }
      .icon-white { fill: white; }
    </style>
  </defs>
  <path d="M15 0 H70 L100 30 V125 A5 5 0 0 1 95 130 H15 A5 5 0 0 1 10 125 V5 A5 5 0 0 1 15 0 Z" class="xlsx-main"/>
  <path d="M70 0 V30 H100 Z" class="xlsx-fold"/>
  <path d="M70 0 L100 30 L70 30 Z" fill="#000" opacity="0.2"/>
  <rect x="10" y="85" width="90" height="35" rx="5" ry="5" class="xlsx-banner"/>
  <text x="55" y="110" class="text-long">XLSX</text>
  <path d="M30 40 H80 V75 H30 Z M30 52 H80 M30 64 H80 M46 40 V75 M63 40 V75" stroke="white" stroke-width="4" fill="none" class="icon-white"/>
</svg>`,

  ods: `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 130" width="70px" height="90px">
  <defs>
    <style>
      .ods-main { fill: #34A853; }
      .ods-fold { fill: #2E8B57; }
      .ods-banner { fill: #257e4a; }
      .text { font-family: Arial, sans-serif; font-weight: bold; fill: white; font-size: 26px; text-anchor: middle; }
      .icon-white { fill: white; }
    </style>
  </defs>
  <path d="M15 0 H70 L100 30 V125 A5 5 0 0 1 95 130 H15 A5 5 0 0 1 10 125 V5 A5 5 0 0 1 15 0 Z" class="ods-main"/>
  <path d="M70 0 V30 H100 Z" class="ods-fold"/>
  <path d="M70 0 L100 30 L70 30 Z" fill="#000" opacity="0.2"/>
  <rect x="10" y="85" width="90" height="35" rx="5" ry="5" class="ods-banner"/>
  <text x="55" y="112" class="text">ODS</text>
  <path d="M30 40 H80 V75 H30 Z M30 52 H80 M30 64 H80 M46 40 V75 M63 40 V75" stroke="white" stroke-width="4" fill="none" class="icon-white"/>
</svg>`,

  ppt: `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 130" width="70px" height="90px">
  <defs>
    <style>
      .ppt-main { fill: #EA4335; }
      .ppt-fold { fill: #C62828; }
      .ppt-banner { fill: #c4382c; }
      .text { font-family: Arial, sans-serif; font-weight: bold; fill: white; font-size: 26px; text-anchor: middle; }
      .icon-white { fill: white; }
    </style>
  </defs>
  <path d="M15 0 H70 L100 30 V125 A5 5 0 0 1 95 130 H15 A5 5 0 0 1 10 125 V5 A5 5 0 0 1 15 0 Z" class="ppt-main"/>
  <path d="M70 0 V30 H100 Z" class="ppt-fold"/>
  <path d="M70 0 L100 30 L70 30 Z" fill="#000" opacity="0.2"/>
  <rect x="10" y="85" width="90" height="35" rx="5" ry="5" class="ppt-banner"/>
  <text x="55" y="112" class="text">PPT</text>
  <rect x="28" y="38" width="54" height="40" rx="2" ry="2" stroke="white" stroke-width="3" fill="none" class="icon-white"/>
  <rect x="35" y="45" width="20" height="20" fill="white" class="icon-white"/>
  <rect x="60" y="45" width="15" height="4" rx="1" ry="1" fill="white" class="icon-white"/>
  <rect x="60" y="52" width="15" height="4" rx="1" ry="1" fill="white" class="icon-white"/>
  <rect x="60" y="59" width="10" height="4" rx="1" ry="1" fill="white" class="icon-white"/>
</svg>`
};

export const icons_doc3 = {
  pdf: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 130" width="70px" height="90px"><defs><style>.main-red { fill: #E53935; } .text { font-family: Arial, Helvetica, sans-serif; font-weight: 900; fill: white; font-size: 32px; }</style></defs><path d="M10 0 H70 L100 30 V120 A10 10 0 0 1 90 130 H10 A10 10 0 0 1 0 120 V10 A10 10 0 0 1 10 0 Z" class="main-red"/><path d="M70 0 V30 H100 L70 0 Z" fill="#B71C1C" opacity="0.4"/><path d="M70 0 L100 30 L70 30 Z" fill="#FFEBEE" opacity="0.3"/><text x="50" y="90" text-anchor="middle" class="text">PDF</text></svg>`,
  doc: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 130" width="70px" height="90px"><defs><style>.main-blue { fill: #2196F3; } .text { font-family: Arial, Helvetica, sans-serif; font-weight: 900; fill: white; font-size: 32px; }</style></defs><path d="M10 0 H70 L100 30 V120 A10 10 0 0 1 90 130 H10 A10 10 0 0 1 0 120 V10 A10 10 0 0 1 10 0 Z" class="main-blue"/><path d="M70 0 V30 H100 L70 0 Z" fill="#0D47A1" opacity="0.4"/><path d="M70 0 L100 30 L70 30 Z" fill="#E3F2FD" opacity="0.3"/><text x="50" y="90" text-anchor="middle" class="text">DOC</text></svg>`,
  docx: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 130" width="70px" height="90px"><defs><style>.main-blue { fill: #2196F3; } .text { font-family: Arial, Helvetica, sans-serif; font-weight: 900; fill: white; font-size: 28px; }</style></defs><path d="M10 0 H70 L100 30 V120 A10 10 0 0 1 90 130 H10 A10 10 0 0 1 0 120 V10 A10 10 0 0 1 10 0 Z" class="main-blue"/><path d="M70 0 V30 H100 L70 0 Z" fill="#0D47A1" opacity="0.4"/><path d="M70 0 L100 30 L70 30 Z" fill="#E3F2FD" opacity="0.3"/><text x="50" y="90" text-anchor="middle" class="text">DOCX</text></svg>`,
  odt: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 130" width="70px" height="90px"><defs><style>.main-blue { fill: #1565C0; } .text { font-family: Arial, Helvetica, sans-serif; font-weight: 900; fill: white; font-size: 32px; }</style></defs><path d="M10 0 H70 L100 30 V120 A10 10 0 0 1 90 130 H10 A10 10 0 0 1 0 120 V10 A10 10 0 0 1 10 0 Z" class="main-blue"/><path d="M70 0 V30 H100 L70 0 Z" fill="#0D47A1" opacity="0.4"/><path d="M70 0 L100 30 L70 30 Z" fill="#E3F2FD" opacity="0.3"/><text x="50" y="90" text-anchor="middle" class="text">ODT</text></svg>`,
  ods: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 130" width="70px" height="90px"><defs><style>.main-green { fill: #43A047; } .text { font-family: Arial, Helvetica, sans-serif; font-weight: 900; fill: white; font-size: 32px; }</style></defs><path d="M10 0 H70 L100 30 V120 A10 10 0 0 1 90 130 H10 A10 10 0 0 1 0 120 V10 A10 10 0 0 1 10 0 Z" class="main-green"/><path d="M70 0 V30 H100 L70 0 Z" fill="#1B5E20" opacity="0.4"/><path d="M70 0 L100 30 L70 30 Z" fill="#E8F5E9" opacity="0.3"/><text x="50" y="90" text-anchor="middle" class="text">ODS</text></svg>`,
  ppt: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 130" width="70px" height="90px"><defs><style>.main-orange { fill: #D84315; } .text { font-family: Arial, Helvetica, sans-serif; font-weight: 900; fill: white; font-size: 32px; }</style></defs><path d="M10 0 H70 L100 30 V120 A10 10 0 0 1 90 130 H10 A10 10 0 0 1 0 120 V10 A10 10 0 0 1 10 0 Z" class="main-orange"/><path d="M70 0 V30 H100 L70 0 Z" fill="#BF360C" opacity="0.4"/><path d="M70 0 L100 30 L70 30 Z" fill="#FBE9E7" opacity="0.3"/><text x="50" y="90" text-anchor="middle" class="text">PPT</text></svg>`,
  pptx: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 130" width="70px" height="90px"><defs><style>.main-orange { fill: #D84315; } .text { font-family: Arial, Helvetica, sans-serif; font-weight: 900; fill: white; font-size: 28px; }</style></defs><path d="M10 0 H70 L100 30 V120 A10 10 0 0 1 90 130 H10 A10 10 0 0 1 0 120 V10 A10 10 0 0 1 10 0 Z" class="main-orange"/><path d="M70 0 V30 H100 L70 0 Z" fill="#BF360C" opacity="0.4"/><path d="M70 0 L100 30 L70 30 Z" fill="#FBE9E7" opacity="0.3"/><text x="50" y="90" text-anchor="middle" class="text">PPTX</text></svg>`,
  xls: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 130" width="70px" height="90px"><defs><style>.main-green { fill: #2E7D32; } .text { font-family: Arial, Helvetica, sans-serif; font-weight: 900; fill: white; font-size: 32px; }</style></defs><path d="M10 0 H70 L100 30 V120 A10 10 0 0 1 90 130 H10 A10 10 0 0 1 0 120 V10 A10 10 0 0 1 10 0 Z" class="main-green"/><path d="M70 0 V30 H100 L70 0 Z" fill="#1B5E20" opacity="0.4"/><path d="M70 0 L100 30 L70 30 Z" fill="#E8F5E9" opacity="0.3"/><text x="50" y="90" text-anchor="middle" class="text">XLS</text></svg>`,
  xlsx: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 130" width="70px" height="90px"><defs><style>.main-green { fill: #2E7D32; } .text { font-family: Arial, Helvetica, sans-serif; font-weight: 900; fill: white; font-size: 28px; }</style></defs><path d="M10 0 H70 L100 30 V120 A10 10 0 0 1 90 130 H10 A10 10 0 0 1 0 120 V10 A10 10 0 0 1 10 0 Z" class="main-green"/><path d="M70 0 V30 H100 L70 0 Z" fill="#1B5E20" opacity="0.4"/><path d="M70 0 L100 30 L70 30 Z" fill="#E8F5E9" opacity="0.3"/><text x="50" y="90" text-anchor="middle" class="text">XLSX</text></svg>`,

};

export const icons_doc2 = {
pdf: `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 130" width="70px" height="90px">
  <defs><style>.pdf-main{fill:#D32F2F;}.pdf-banner{fill:#B71C1C;}.pdf-fold{fill:#9A0007;}.text{font-family:Arial,Helvetica,sans-serif;font-weight:900;fill:white;font-size:30px;text-anchor:middle;}</style></defs>
  <path d="M10 0 H70 L100 30 V120 A10 10 0 0 1 90 130 H20 A10 10 0 0 1 10 120 V0 Z" class="pdf-main"/>
  <path d="M70 0 V30 H100 L70 0 Z" class="pdf-fold" opacity="0.5"/>
  <path d="M70 0 L100 30 L70 30 Z" fill="white" opacity="0.2"/>
  <rect x="5" y="65" rx="4" ry="4" width="90" height="40" class="pdf-banner"/>
  <text x="50" y="96" class="text">PDF</text>
</svg>`,

  doc: `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 130" width="70px" height="90px">
  <defs><style>.doc-main{fill:#1976D2;}.doc-banner{fill:#1565C0;}.doc-fold{fill:#0D47A1;}.text{font-family:Arial,Helvetica,sans-serif;font-weight:900;fill:white;font-size:30px;text-anchor:middle;}</style></defs>
  <path d="M10 0 H70 L100 30 V120 A10 10 0 0 1 90 130 H20 A10 10 0 0 1 10 120 V0 Z" class="doc-main"/>
  <path d="M70 0 V30 H100 L70 0 Z" class="doc-fold" opacity="0.5"/>
  <path d="M70 0 L100 30 L70 30 Z" fill="white" opacity="0.2"/>
  <rect x="5" y="65" rx="4" ry="4" width="90" height="40" class="doc-banner"/>
  <text x="50" y="96" class="text">DOC</text>
</svg>`,

  docx: `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 130" width="70px" height="90px">
  <defs><style>.docx-main{fill:#1976D2;}.docx-banner{fill:#1565C0;}.docx-fold{fill:#0D47A1;}.text-long{font-family:Arial,Helvetica,sans-serif;font-weight:900;fill:white;font-size:24px;text-anchor:middle;}</style></defs>
  <path d="M10 0 H70 L100 30 V120 A10 10 0 0 1 90 130 H20 A10 10 0 0 1 10 120 V0 Z" class="docx-main"/>
  <path d="M70 0 V30 H100 L70 0 Z" class="docx-fold" opacity="0.5"/>
  <path d="M70 0 L100 30 L70 30 Z" fill="white" opacity="0.2"/>
  <rect x="5" y="65" rx="4" ry="4" width="90" height="40" class="docx-banner"/>
  <text x="50" y="94" class="text-long">DOCX</text>
</svg>`,

  odt: `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 130" width="70px" height="90px">
  <defs><style>.odt-main{fill:#1976D2;}.odt-banner{fill:#1565C0;}.odt-fold{fill:#0D47A1;}.text{font-family:Arial,Helvetica,sans-serif;font-weight:900;fill:white;font-size:30px;text-anchor:middle;}</style></defs>
  <path d="M10 0 H70 L100 30 V120 A10 10 0 0 1 90 130 H20 A10 10 0 0 1 10 120 V0 Z" class="odt-main"/>
  <path d="M70 0 V30 H100 L70 0 Z" class="odt-fold" opacity="0.5"/>
  <path d="M70 0 L100 30 L70 30 Z" fill="white" opacity="0.2"/>
  <rect x="5" y="65" rx="4" ry="4" width="90" height="40" class="odt-banner"/>
  <text x="50" y="96" class="text">ODT</text>
  </svg>`,
  
  xls: `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 130" width="70px" height="90px">
  <defs><style>.xls-main{fill:#388E3C;}.xls-banner{fill:#2E7D32;}.xls-fold{fill:#1B5E20;}.text{font-family:Arial,Helvetica,sans-serif;font-weight:900;fill:white;font-size:30px;text-anchor:middle;}</style></defs>
  <path d="M10 0 H70 L100 30 V120 A10 10 0 0 1 90 130 H20 A10 10 0 0 1 10 120 V0 Z" class="xls-main"/>
  <path d="M70 0 V30 H100 L70 0 Z" class="xls-fold" opacity="0.5"/>
  <path d="M70 0 L100 30 L70 30 Z" fill="white" opacity="0.2"/>
  <rect x="5" y="65" rx="4" ry="4" width="90" height="40" class="xls-banner"/>
  <text x="50" y="96" class="text">XLS</text>
  </svg>`,
  
  xlsx: `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 130" width="70px" height="90px">
  <defs><style>.xlsx-main{fill:#388E3C;}.xlsx-banner{fill:#2E7D32;}.xlsx-fold{fill:#1B5E20;}.text-long{font-family:Arial,Helvetica,sans-serif;font-weight:900;fill:white;font-size:24px;text-anchor:middle;}</style></defs>
  <path d="M10 0 H70 L100 30 V120 A10 10 0 0 1 90 130 H20 A10 10 0 0 1 10 120 V0 Z" class="xlsx-main"/>
  <path d="M70 0 V30 H100 L70 0 Z" class="xlsx-fold" opacity="0.5"/>
  <path d="M70 0 L100 30 L70 30 Z" fill="white" opacity="0.2"/>
  <rect x="5" y="65" rx="4" ry="4" width="90" height="40" class="xlsx-banner"/>
  <text x="50" y="94" class="text-long">XLSX</text>
  </svg>`,
  
  ods: `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 130" width="70px" height="90px">
  <defs><style>.ods-main{fill:#388E3C;}.ods-banner{fill:#2E7D32;}.ods-fold{fill:#1B5E20;}.text{font-family:Arial,Helvetica,sans-serif;font-weight:900;fill:white;font-size:30px;text-anchor:middle;}</style></defs>
  <path d="M10 0 H70 L100 30 V120 A10 10 0 0 1 90 130 H20 A10 10 0 0 1 10 120 V0 Z" class="ods-main"/>
  <path d="M70 0 V30 H100 L70 0 Z" class="ods-fold" opacity="0.5"/>
  <path d="M70 0 L100 30 L70 30 Z" fill="white" opacity="0.2"/>
  <rect x="5" y="65" rx="4" ry="4" width="90" height="40" class="ods-banner"/>
  <text x="50" y="96" class="text">ODS</text>
  </svg>`,
  
  ppt: `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 130" width="70px" height="90px">
  <defs><style>.ppt-main{fill:#E64A19;}.ppt-banner{fill:#D84315;}.ppt-fold{fill:#BF360C;}.text{font-family:Arial,Helvetica,sans-serif;font-weight:900;fill:white;font-size:30px;text-anchor:middle;}</style></defs>
  <path d="M10 0 H70 L100 30 V120 A10 10 0 0 1 90 130 H20 A10 10 0 0 1 10 120 V0 Z" class="ppt-main"/>
  <path d="M70 0 V30 H100 L70 0 Z" class="ppt-fold" opacity="0.5"/>
  <path d="M70 0 L100 30 L70 30 Z" fill="white" opacity="0.2"/>
  <rect x="5" y="65" rx="4" ry="4" width="90" height="40" class="ppt-banner"/>
  <text x="50" y="96" class="text">PPT</text>
  </svg>`
};

